import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage, setSortBy } from "../../features/filters/filterSlice";

const Filter = () => {
	const dispatch = useDispatch();
	const { sortBy } = useSelector((state) => state.filters);

	const handleSortby = (e) => {
		e.preventDefault();
		dispatch(setSortBy(e.target.value));
		dispatch(setCurrentPage(1))
	};

	return (
		<div className="order-first md:order-none">
			<select
				name=""
				className="h-10 border border-slate-400 rounded-md outline-none focus:border focus:border-green-600 focus:ring-0 focus:outline-none"
				onChange={handleSortby}
				defaultValue={sortBy}
			>
				<option value="">Default</option>
				<option value="expense">Expense</option>
				<option value="income">Income</option>
			</select>
		</div>
	);
};

export default Filter;
